import * as React from 'react';
import { Box } from '@mui/material';

import WaiverText from './WaiverText';

// The language a waiver is shown and signed in: the chosen one where the waiver has it, else its first.
export const getEffectiveWaiverLang = (waiver, lang) => {
    const values = waiver?.text?.values || {};
    return values[lang] ? lang : Object.keys(values)[0];
}

// The parent owns the language, so the signature records the language the guest read.
export const WaiverList = ({ waivers, lang, onLanguageChange }) => {
    return (<>
        {waivers.map((waiver, idx) => (
            <Box key={idx} className="bordered-box" sx={{ mt: 2, mb: 3 }}>
                <WaiverText
                    waiver={waiver}
                    lang={getEffectiveWaiverLang(waiver, lang)}
                    onLanguageChange={onLanguageChange}
                />
            </Box>
        ))}
    </>);
}

export default WaiverList;
